/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoPayoutAccountSetStatus } from '../../models/dto-payout-account-set-status';

export interface BookingControllerPayoutAccountSetStatus$Params {
  id: number;
      body: DtoPayoutAccountSetStatus
}

export function bookingControllerPayoutAccountSetStatus(http: HttpClient, rootUrl: string, params: BookingControllerPayoutAccountSetStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerPayoutAccountSetStatus.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

bookingControllerPayoutAccountSetStatus.PATH = '/booking/wallet/payout_accounts/{id}/status';
